import { render, staticRenderFns } from "./screenShotDialog.vue?vue&type=template&id=bc07ef16&scoped=true"
import script from "./screenShotDialog.vue?vue&type=script&lang=js"
export * from "./screenShotDialog.vue?vue&type=script&lang=js"
import style0 from "./screenShotDialog.vue?vue&type=style&index=0&id=bc07ef16&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc07ef16",
  null
  
)

export default component.exports